module.exports = __webpack_public_path__ + "static/media/arrow-select-down-blue.3830a454.svg";